import {
  DeleteObjectCommand,
  GetObjectCommand,
  ListObjectsCommand,
  PutObjectCommand,
  S3Client,
} from "@aws-sdk/client-s3";
import { inflate } from "pako";
import { S3_BUCKET, S3_SIGNATURES_BUCKET, S3_LOGS_BUCKET } from "./constants";
import store from "@/store";

// This needs to be a function to get the credentials from the store
// Otherwise, the credentials are not updated when the user changes
export const s3 = async () => {
  const secret = await store.getters["operators/secret"]("storage");
  if (!secret?.key) {
    alert("Es necesario cerrar sesión y volver a entrar de la aplicación.");
    throw new Error("No credentials found");
  }
  return new S3Client({
    region: "eu-west-1",
    credentials: {
      accessKeyId: secret.key,
      secretAccessKey: secret.secret,
    },
  });
};

function s3Url(path) {
  return `https://s3.eu-west-1.amazonaws.com/${S3_BUCKET}/${path}`;
}

export async function deleteTicketImage(wgId, ticketId, id) {
  const file = `${wgId}/tickets/${ticketId}/${id}.jpg`;
  await (
    await s3()
  ).send(
    new DeleteObjectCommand({
      Key: file,
      Bucket: S3_BUCKET,
    })
  );
}

export async function listBackups(wgId) {
  const data = await (
    await s3()
  ).send(
    new ListObjectsCommand({
      Bucket: "backups.db.2kbo.com",
      Prefix: `startedByOp/${wgId}_`,
    })
  );
  return data.Contents;
}

export async function uploadTicketImage(wgId, ticketId, id, data, mimeType = "image/jpeg") {
  const file = `${wgId}/tickets/${ticketId}/${id}.jpg`;
  await (
    await s3()
  ).send(
    new PutObjectCommand({
      Key: file,
      ContentType: mimeType,
      Body: data,
      Bucket: S3_BUCKET,
      ACL: "public-read",
    })
  );
  return s3Url(file);
}

export async function downloadSignature(path) {
  const data = await (
    await s3()
  ).send(
    new GetObjectCommand({
      Key: path,
      Bucket: S3_SIGNATURES_BUCKET,
    })
  );
  const b64Data = await data.Body.transformToString();
  return `data:image/png;base64,${b64Data}`;
}

export async function getExtendedAudit(s3Url) {
  const [, , bucket, ...keyParts] = s3Url.split("/");
  const key = keyParts.join("/");
  const data = await (
    await s3()
  ).send(
    new GetObjectCommand({
      Key: key,
      Bucket: bucket,
    })
  );
  if (key.endsWith(".zip") || key.endsWith(".gz")) {
    const body = await data.Body.transformToByteArray();
    const json = await inflate(body, { to: "string" });
    return JSON.parse(json);
  } else {
    return JSON.parse(await data.Body.transformToString());
  }
}
